if (!window.moqAlertInitialized) {
  window.moqAlertInitialized = true;

  document.addEventListener('submit', function (evt) {
    const form = evt.target;
    if (!form || form.tagName !== 'FORM') return;

    const qtyInput = form.querySelector('input[name="quantity"][data-min]');
    if (!qtyInput) return;

    const min = parseInt(qtyInput.dataset.min, 10);
    if (isNaN(min) || min <= 1) return;

    const currentQty = parseInt(qtyInput.value, 10);
    if (isNaN(currentQty) || currentQty >= min) return;

    if (!qtyInput.id || !qtyInput.id.startsWith('Quantity-')) return;
    const sectionId = qtyInput.id.slice('Quantity-'.length);
    const modal = Array.from(document.querySelectorAll('modal-dialog[data-moq-section]')).find(
      (dialog) => dialog.dataset.moqSection === sectionId
    );
    if (!modal || typeof modal.show !== 'function') return;

    const currentIdInput = form.querySelector('input[name="id"]');
    if (
      currentIdInput &&
      modal.dataset.singleVariantId &&
      currentIdInput.value === modal.dataset.singleVariantId
    ) {
      return; // customer is already on the Accept Higher Price variant -- don't re-prompt
    }

    evt.preventDefault();
    evt.stopImmediatePropagation();

    qtyInput.value = min;
    qtyInput.dispatchEvent(new Event('change', { bubbles: true }));

    const body = modal.querySelector('[data-moq-alert-body]');
    if (body && modal.dataset.bodyTemplate) {
      body.textContent = modal.dataset.bodyTemplate.replaceAll('[QTY]', min);
    }

    const confirmLabel = modal.querySelector('[data-moq-confirm-label]');
    if (confirmLabel && modal.dataset.confirmTemplate) {
      confirmLabel.textContent = modal.dataset.confirmTemplate.replaceAll('[QTY]', min);
    }

    modal.moqForm = form;
    modal.moqQtyInput = qtyInput;
    modal.show(evt.submitter || form);
  }, true);

  document.addEventListener('click', function (evt) {
    const target = evt.target.closest('[data-moq-confirm], [data-moq-edit], [data-moq-single], [data-moq-close]');
    if (!target) return;

    const modal = target.closest('modal-dialog[data-moq-section]');
    if (!modal) return;

    evt.preventDefault();

    if (target.matches('[data-moq-confirm]')) {
      const form = modal.moqForm;
      modal.moqForm = null;
      modal.moqQtyInput = null;
      modal.hide();
      if (form && typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      }
      return;
    }

    if (target.matches('[data-moq-single]')) {
      const form = modal.moqForm;
      const singleQtyInput = modal.moqQtyInput;
      const singleVariantId = target.dataset.singleVariantId || modal.dataset.singleVariantId;
      modal.moqForm = null;
      modal.moqQtyInput = null;
      modal.hide();
      if (form && singleVariantId) {
        const idInput = form.querySelector('input[name="id"]');
        if (idInput) {
          idInput.value = singleVariantId;
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (singleQtyInput) {
          singleQtyInput.min = '1';
          singleQtyInput.removeAttribute('data-min');
          singleQtyInput.value = 1;
          singleQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        }
      }
      return;
    }

    const qtyInput = modal.moqQtyInput;
    if (qtyInput) modal.openedBy = qtyInput;
    if (target.matches('[data-moq-edit]')) modal.hide();
    modal.moqForm = null;
    modal.moqQtyInput = null;
  });
}
